import CardBox from "gatsby-theme-dettol/src/components/common/CardBox/CardBox"

import "./CardBoxOverride.scss"

export default CardBox